import chengeBuyLink from './chengeBuyLink.ts';
import addPurchaseInfoToComment from './addPurchaseInfoToComment.ts';
import {changeBasketAmount, changeAmount} from './changeBasketAmount.ts';
import productCounter from './productCounter.ts';

export {
    chengeBuyLink,
    addPurchaseInfoToComment,
    changeBasketAmount,
    productCounter,
    changeAmount
}